<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card min-height">
          <TableLoading v-if="order.publicId === '0'"/>
          <div v-else class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Invoice # {{order.invoiceId}}</h4>
              <div class="mb-4">
                <img
                    src="@/assets/images/KikkomanNameLogo.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>From:</strong>
                  <br />Kikkoman East Africa <br/>P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                  <br />Pin P051667186Z
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <br />{{ order.customer.name }}
                  <br/>CUSTOMER CODE: {{ order.customer.customerCode }}
                  <br />LPO No #: {{order.lpo}}
                  <br />Order by: {{order.orderedBy}}
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3"></div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Payment Due Date:</strong>
                  <br /> {{ order.paymentDueDate }}
                  <br /><br />
                </address>
              </div>
            </div>
            <div class="my-5 ml-3">
              <add-product-component v-if="isUserStaff()" :products="order.customer.validOrderProducts" :orderId="order.publicId" @addItemToOrder="addItemToOrder"/>
              <customer-add-product-component v-else :products="order.customer.validOrderProducts" :orderId="order.publicId" @addItemToOrder="addItemToOrder"/>
            </div>
            <div class="my-5">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 70px">No.</th>
                      <th>Product Name</th>
                      <th v-if="checkForPermission(change_order_shipment_permission)">Shipments</th>
                      <th>Unit Price</th>
                      <th>Order Unit</th>
                      <th>Order Unit Pieces</th>
                      <th>Discount</th>
                      <th class="text-sm-end">Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item,index) in order.orderItems" :key="item.publicId">
                    <tr>
                      <td>{{ index + 1 }}</td>
                      <td>{{item.item.productName}}<br/>
                        <span class="font-italic" style="font-size: 9px">(Warehouse: {{item.warehouse.name}})</span><br/>
                      </td>
                      <td v-if="checkForPermission(change_order_shipment_permission)">
                        <multiselect v-model="item.shipments" :options="item.item.shipments" class="multiselect-height-3" :disabled="item.item.shipments.length == '1'"
                                     placeholder="Select one" :custom-label="customLabel" track-by="orderId" :multiple="true" :searchable="true">
                          <span slot="noResult">No shipment found. Change search query.</span>
                        </multiselect>
                      </td>
                      <td>Ksh {{item.itemPrice | formatNumber}}</td>
                      <td v-if="checkForPermission(change_order_item_permission)"><b-form-input :value="item.itemCount" class="px-4 w-50" style="outline: 0;border-width: 0 0 2px;border-radius: 0"></b-form-input></td>
                      <td v-else>{{item.itemCount}}</td>
                      <td>{{ item.item.qpoUnit }}</td>
                      <td>
                        <span v-if="item.itemDiscountRecord">Ksh {{item.itemDiscountRecord.orderItemDiscountAmount | formatNumber}}</span>
                        <span v-else>No Discount</span>
                      </td>
                      <td class="text-sm-end">Ksh {{item.grossItemTotal | formatNumber}}</td>
                      <td>
                        <div class="button-items">
                          <b-button variant="dark" size="sm" disabled v-if="ordersLoading">
                            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </b-button>
                          <b-button variant="dark" size="sm" class="py-1 text-white mb-2" @click="updateOrderItem(item)" :disabled="ordersLoading" v-if="checkForPermission(change_order_item_permission)">
                            Update
                          </b-button>
                          <b-button variant="danger" size="sm" class="py-1 text-white" @click="removeItemFromOrder(item.publicId)" :disabled="ordersLoading" v-if="checkForPermission(delete_order_item_permission)">
                            Remove
                          </b-button>
                          <div v-if="item.isDiscountApplied">
                            <b-button v-b-modal.edit-item-discount @click="setDiscountItem(item)" variant="info" size="sm" class="py-1 text-white" :disabled="ordersLoading" v-if="checkForPermission(change_order_item_discount_permission)">
                              Update Discount
                            </b-button>
                            <b-button variant="warning" size="sm" class="py-1 text-white" @click="deleteItemDiscount(item.itemDiscountRecord)" :disabled="ordersLoading">
                              Remove Discount
                            </b-button>
                          </div>
                          <div v-else>
                            <b-button v-b-modal.item-discount @click="setItemId(item.publicId)" variant="secondary" size="sm" class="py-1 text-white" :disabled="ordersLoading" v-if="checkForPermission(add_order_item_discount_permission)">
                              Add Discount
                            </b-button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row justify-content-between my-5">
                  <div class="col-4">
                    <div class="my-2 pb-2" v-if="order.orderDiscountRecord">
                      <strong>Overall Discount:</strong>
                      <p class="float-end">Ksh {{order.orderDiscountRecord.orderDiscountAmount | formatNumber}}</p>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="my-2 pb-2">
                      <strong>VAT:</strong>
                      <p class="float-end">Ksh {{order.orderVat | formatNumber}}</p>
                    </div>
                    <div class="my-2 pb-2">
                      <strong>Discount Applied:</strong>
                      <p class="float-end">Ksh {{order.orderDiscount | formatNumber}}</p>
                    </div>
                    <div class="my-2 pb-2">
                      <strong>Surcharge:</strong>
                      <p class="float-end">Ksh {{order.orderSurchargeAmount | formatNumber}}</p>
                    </div>
                    <div class="my-2 pb-2">
                      <strong>Total:</strong>
                      <p class="float-end">Ksh {{order.grossOrderTotal | formatNumber}}</p>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-start my-5">
                  <div class="col-5">
                    <div class="button-items">
                      <b-button variant="success" size="lg" class="py-1 text-white" @click="checkOrderValidity(order.publicId)">
                        Check Order
                      </b-button>
                      <b-button v-if="order.canCancelOrder" variant="danger" size="lg" class="py-1 text-white" @click="cancelOrder(order.publicId)">
                        Cancel Order
                      </b-button>
                      <div v-if="order.orderDiscountRecord">
                        <b-button v-b-modal.edit-overall-discount @click="setDiscount(order.orderDiscountRecord)" variant="info" size="sm" class="py-1 text-white" :disabled="ordersLoading" v-if="checkForPermission(edit_order_discount_permission)">
                          Update Overall Discount
                        </b-button>
                        <b-button variant="warning" size="sm" class="py-1 text-white" @click="deleteOverallDiscount(order.orderDiscountRecord)" :disabled="ordersLoading" v-if="checkForPermission(delete_order_discount_permission)">
                          Remove Overall Discount
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button v-b-modal.overall-discount variant="secondary" size="lg" class="py-1 text-white" v-if="checkForPermission(add_order_discount_permission)">
                          Add Overall Order Discount
                        </b-button>
                      </div>
                      <div class="button-items">
                        <b-button v-b-modal.order-surcharge variant="dark" size="lg" class="py-1 text-white" v-if="checkForPermission(set_order_surcharge_permission)">
                          Order Surcharge
                        </b-button>
                        <b-button v-if="order.surchargePercentage !== null && checkForPermission(delete_order_surcharge_permission)" variant="danger" size="lg" class="py-1 text-white" @click="deleteSurcharge(order.publicId)" :disabled="ordersLoading">
                          Remove Order Surcharge
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-modal
              id="item-discount"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Item Name Discount</h3>
              <order-discount-modal-component button_color="info" button_text="Add Item discount" @addDiscount="addItemDiscount"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('item-discount')">Close</b-button>
            </div>
          </b-modal>
          <b-modal
              id="edit-item-discount"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Edit Item Discount</h3>
              <order-discount-modal-component button_color="info" :discount-item="discount_item" button_text="Edit Item discount" @addDiscount="updateItemDiscount"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-item-discount')">Close</b-button>
            </div>
          </b-modal>
          <b-modal
              id="overall-discount"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Order Discount</h3>
              <order-discount-modal-component button_color="secondary" button_text="Add Overall Discount" @addDiscount="addOverallDiscount"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('overall-discount')">Close</b-button>
            </div>
          </b-modal>
          <b-modal
              id="edit-overall-discount"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Edit Order Discount</h3>
              <order-discount-modal-component :discount-item="discount_item" button_color="secondary" button_text="Edit Overall Discount" @addDiscount="updateOverallDiscount"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-overall-discount')">Close</b-button>
            </div>
          </b-modal>
          <b-modal
              id="order-surcharge"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Order Surcharge</h3>
              <order-surcharge-modal-component :surcharge-item="order.surchargePercentage" button_color="primary" button_text="Update Order Surcharge" @addSurcharge="addSurcharge"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('order-surcharge')">Close</b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import AddProductComponent from "@/components/orders/customize_order/add-product-component";
import OrderDiscountModalComponent from "@/components/orders/customize_order/order-discount-modal-component";
import {SINGLE_CUSTOMER_ORDER} from "@/gql/orders";
import {mapActions, mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import Swal from "sweetalert2";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import OrderSurchargeModalComponent from "@/components/orders/customize_order/order-surcharge-modal-component";
import {permissions} from "@/router/permissions";
import CustomerAddProductComponent from "@/components/orders/customize_order/customer-add-product-component";
import moment from "moment";

export default {
  page: {
    title: "Customize Order",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    CustomerAddProductComponent,
    OrderSurchargeModalComponent,Multiselect,
    TableLoading, OrderDiscountModalComponent, AddProductComponent, PageHeader, Layout},
name: "customize-order",
  data() {
    return {
      title: "Customize Order",
      items: [
        {
          text: "Orders",
          href: routeItems.customer_orders_route
        },
        {
          text: "Customize Order",
          active: true
        }
      ],
      order: {
        publicId: '0',
        invoiceId: "",
        lpo: "",
        deliveryDate: "",
        timezone: {
          timezoneName:""
        },
        orderedBy:"",
        paymentDueDate:"",
        status: {
          orderStatusName:"",
        },
        customer: {
          name: "",
          customerCode: "",
          addressLine1: "",
          street: "",
          institutionId: {
            name: "",
            pin: "",
            postalCode: "",
            institutionCode: "",
            phoneNumber: "",
          },
          validOrderDays: {
            weekday: ""
          },
          validOrderProducts :[{
            publicId: "",
            productName: ""
          }]
        },
        orderItems: [{
          item: {
            productName: "",
            qpoUnit: "",
            shipments: [{
              publicId: "",
              orderId: "",
            }],
          },
          itemPrice: "",
          isDiscountApplied: "",
          itemDiscountRecord: {
            publicId: "",
            orderItemDiscountAmount: "",
            orderItemDiscountPercentage: "",
          },
          itemDiscount: "",
          netItemTotal: "",
          itemVat: "",
          grossItemTotal: "",
          shipments: [{
            publicId: "",
            orderId: ""
          }],
        }],
        netOrderTotal: "",
        orderVat: "",
        orderDiscount: "",
        orderDiscountRecord: {
          publicId: "",
          orderDiscountAmount: "",
          orderDiscountPercentage: "",
        },
        orderSurchargeAmount: "",
        surchargePercentage: null,
        grossOrderTotal: "",
        canCancelOrder: false
      },
      quantity: 34,
      item_id: "",
      discount_item: {
        percentage: '',
        amount: '',
        discount_record: ''
      },
      change_order_shipment_permission: permissions.change_order_shipment_permission,
      set_order_surcharge_permission: permissions.set_order_surcharge_permission,
      delete_order_surcharge_permission: permissions.delete_order_surcharge_permission,
      delete_order_item_permission: permissions.delete_order_item_permission,
      change_order_item_permission: permissions.change_order_item_permission,
      add_order_item_discount_permission: permissions.add_order_item_discount_permission,
      change_order_item_discount_permission: permissions.change_order_item_discount_permission,
      add_order_discount_permission: permissions.add_order_discount_permission,
      edit_order_discount_permission: permissions.edit_order_discount_permission,
      delete_order_discount_permission: permissions.delete_order_discount_permission
    }
  },
  apollo: {
    order: {
      query: SINGLE_CUSTOMER_ORDER,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
  },
  methods: {
    ... mapActions({
      checkSingleOrderValidity: 'orders/checkSingleOrderValidity',
      changeOrderStatus: 'orders/changeOrderStatus',
      addToOrder: 'orders/addItemToOrder',
      updateOrder: 'orders/updateOrderItem',
      removeFromOrder: 'orders/deleteItemFromOrder',
      addOrderItemDiscount: 'orders/addOrderItemDiscount',
      updateOrderItemDiscount: 'orders/updateOrderItemDiscount',
      deleteOrderItemDiscount: 'orders/deleteOrderItemDiscount',
      addOrderDiscount: 'orders/addOrderDiscount',
      updateOrderDiscount: 'orders/updateOrderDiscount',
      deleteOrderDiscount: 'orders/deleteOrderDiscount',
      addSurchargeToOrder: 'orders/addSurchargeToOrder',
      deleteSurchargeFromOrder: 'orders/deleteSurchargeFromOrder'
    }),
    refetchOrder(){
      this.$apollo.queries.order.refetch()
    },
    setItemId(id){
      this.item_id = id
    },
    setDiscount(item){
      this.discount_item.percentage = item.orderDiscountPercentage
      this.discount_item.amount = item.orderDiscountAmount
    },
    setDiscountItem(item){
      this.discount_item.percentage = item.itemDiscountRecord.orderItemDiscountPercentage
      this.discount_item.amount = item.itemDiscountRecord.orderItemDiscountAmount
      this.discount_item.discount_record = item.itemDiscountRecord.publicId
      this.item_id = item.publicId
    },
    customLabel ({ orderId, warehouseId, expiryDate }) {
      const date = moment(expiryDate).format('ll')
      if (!warehouseId){
        return `${orderId} – No Warehouse - Expiry: ${date}`
      }else {
        return `${orderId} – ${warehouseId?.name} - Expiry: ${date}`
      }
    },
    async updateOrderItem(item){
      const shipment_ids = []
      item.shipments.forEach((id) => {
        shipment_ids.push(id.publicId)
      })
      const data = {
        id: item.publicId,
        order: this.order.publicId,
        itemId: item.item.publicId,
        itemCount: parseInt(item.itemCount),
        warehouseId: item.warehouse.publicId,
        shipments: shipment_ids
      }
      await this.updateOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Item updated successfully`)
          this.refetchOrder()
        }
      })
    },
    async addItemToOrder(data){
      await this.addToOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Item added to order successfully`)
          this.refetchOrder()
        }
      })
    },
    async removeItemFromOrder(id){
      await this.removeFromOrder({'id': id}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async cancelOrder(orderId){
      const data = {orderId: orderId ,statusId: "c518ae7e-0732-46cb-b234-da118cdfd8f9"}
      await this.changeOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async checkOrderValidity(id){
      const data = {'id': id}
      await this.checkSingleOrderValidity(data).then(resp => {
        if(resp.message){
          Swal.fire({
            icon: 'info',
            text: `${resp.message}`,
            showConfirmButton: false,
          })
        }

      })
    },
    async addItemDiscount(percentage, amount){
      const data = {
        orderItemId: this.item_id,
        discountAmount: amount,
        discountPercentage: percentage
      }
      await this.addOrderItemDiscount(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async updateItemDiscount(percentage, amount){
      const data = {
        id: this.discount_item.discount_record,
        orderItemId: this.item_id,
        discountAmount: amount,
        discountPercentage: percentage
      }
      await this.updateOrderItemDiscount(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async deleteItemDiscount(record){
      await this.deleteOrderItemDiscount({'id': record.publicId}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async addOverallDiscount(percentage, amount){
      const data = {
        orderId: this.$route.params.id,
        discountAmount: amount,
        discountPercentage: percentage
      }
      await this.addOrderDiscount(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async updateOverallDiscount(percentage, amount){
      const data = {
        id: this.order.orderDiscountRecord.publicId,
        orderId: this.$route.params.id,
        discountAmount: amount,
        discountPercentage: percentage
      }
      await this.updateOrderDiscount(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async deleteOverallDiscount(record){
      await this.deleteOrderDiscount({'id': record.publicId}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async addSurcharge(percentage){
      const data = {
        id: this.$route.params.id,
        surcharge: percentage
      }
      await this.addSurchargeToOrder(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },
    async deleteSurcharge(publicId){
      await this.deleteSurchargeFromOrder({'id': publicId}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.refetchOrder()
        }
      })
    },

  }
}
</script>

<style scoped>

</style>
